// Reusable brand mark for Hermes.
// Two variants:
//  - default: wing icon + "Hermes" text (compact — sidebar/header)
//  - variant="wordmark": full commercial wordmark (login/marketing headers)
export default function Logo({ size = "md", tone = "light", showSub = true, variant = "default", className = "" }) {
  if (variant === "wordmark") {
    const height = size === "sm" ? "h-8" : size === "lg" ? "h-16" : "h-12";
    return (
      <img
        src="/hermes-wordmark.png"
        alt="Hermes · Tecnologia Jurídica que Impulsiona Resultados"
        className={`${height} w-auto object-contain select-none ${className}`}
        draggable={false}
        data-testid="brand-wordmark"
      />
    );
  }
  const dims = size === "sm" ? "h-8 w-8" : size === "lg" ? "h-12 w-12" : "h-10 w-10";
  const nameSize = size === "sm" ? "text-base" : size === "lg" ? "text-2xl" : "text-lg";
  const subSize = size === "lg" ? "text-sm" : "text-xs";
  const nameColor = tone === "dark" ? "text-white" : "text-slate-900";
  const subColor = tone === "dark" ? "text-[#d4a24c]" : "text-[#a37417]";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-mark">
      <img
        src="/hermes-wing.png"
        alt="Hermes"
        className={`${dims} object-contain shrink-0 drop-shadow-[0_2px_8px_rgba(212,162,76,0.35)]`}
        draggable={false}
      />
      <div className="min-w-0">
        <div className={`font-heading ${nameSize} font-semibold ${nameColor} tracking-[0.08em]`}>HERMES</div>
        {showSub && (
          <div className={`${subSize} ${subColor} truncate font-medium tracking-wide`}>
            Tecnologia jurídica que impulsiona resultados
          </div>
        )}
      </div>
    </div>
  );
}
